export default __webpack_public_path__ + "static/media/settings (2).b92da46c.png";